import React, { useState } from 'react'
import ItemTooltip from './ItemTooltip'

const InventoryItem = ({
  item,
  index,
  sourceType = 'inventory',
  slotType = null,
  isDraggable = true,
  onDragStart,
  onDragEnd,
  onClick,
  className = '',
  showTooltip = true,
}) => {
  const [showTooltipState, setShowTooltipState] = useState(false)
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 })

  const handleMouseEnter = (e) => {
    if (showTooltip && item) {
      const rect = e.currentTarget.getBoundingClientRect()
      setTooltipPosition({
        x: rect.right + 10,
        y: rect.top,
      })
      setShowTooltipState(true)
    }
  }

  const handleMouseLeave = () => {
    setShowTooltipState(false)
  }

  const handleDragStart = (e) => {
    if (isDraggable && onDragStart && item) {
      onDragStart(e, item, sourceType, index)
    }
  }

  const handleDragEnd = (e) => {
    if (onDragEnd) {
      onDragEnd(e)
    }
  }

  const handleClick = () => {
    if (onClick && item) {
      onClick(item, index, sourceType)
    }
  }

  const handleImageError = (e) => {
    e.target.style.display = 'none'
    const fallback = e.target.nextSibling
    if (fallback) {
      fallback.style.display = 'flex'
    }
  }

  const getRarityClass = () => {
    if (!item || !item.rarity) return ''
    return `rarity-${item.rarity}`
  }

  if (!item) {
    return (
      <div className={`inventory-item-empty ${className}`}>
        <div className="inventory__equipment-slot-item">&nbsp;</div>
      </div>
    )
  }

  return (
    <>
      <div
        className={`inventory-item ${getRarityClass()} ${className}`}
        draggable={isDraggable}
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={handleClick}
        title={item.name}
      >
        <div className="inventory__equipment-slot-item">
          {item.image && <img src={item.image} alt={item.name} onError={handleImageError} className="item-image" />}
          <div className="item-name-fallback" style={{ display: item.image ? 'none' : 'flex' }}>
            <span>{item.name}</span>
          </div>
          {item.quantity > 1 && <span className="item-quantity">{item.quantity}</span>}
          {Array.isArray(item.tags) && item.tags.includes('provision') && (
            <span className="item-provision-badge" title="Provisión de viaje">
              Prov.
            </span>
          )}
          {item.isNew && <div className="item-new-indicator"></div>}
        </div>
      </div>

      {showTooltipState && showTooltip && (
        <ItemTooltip item={item} position={tooltipPosition} sourceType={sourceType} slotType={slotType} />
      )}
    </>
  )
}

export default InventoryItem
